import { type ProvisioningPageExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export type { ProvisioningPageExtensionsOptions } from './types';

export const provisioningPageExtensionsWhitelist = ['provisioningPageOptions'];

export const createProvisioningPageExtensions = (options: ProvisioningPageExtensionsOptions) =>
	createProductExtensions<{
		provisioningPageOptions: ProvisioningPageExtensionsOptions;
	}>(provisioningPageExtensionsWhitelist)({
		provisioningPageOptions: options,
	});
